export default class WriteMesssageTimeoutError extends Error {}